var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-wrapper"},[_c('div',{staticClass:"dialog-mask"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }